'use strict';

/**
 *
 * @name: translationsLoader
 *
 */

/* jslint indent: false */

import TRANSLATIONS_CHINEESE from './data/translations.chinese.json';
import TRANSLATIONS_HONGKONG from './data/translations.hongkong.json';
import TRANSLATIONS_ENGLISH from './data/translations.english.json';

function TranslationsLoaderFactory($q) {

  'ngInject';

  return function(options) {

    let deferred = $q.defer()
    let translations

    switch (options.key) {
      case 'en-us':
        translations = TRANSLATIONS_ENGLISH
        break;

      case 'zh-cn':
        translations = TRANSLATIONS_CHINEESE
        break;

      case 'zh-hk':
        translations = TRANSLATIONS_HONGKONG
        break;

      default:
        break;
    }

    deferred.resolve(translations);

    return deferred.promise;
  };
}

export default TranslationsLoaderFactory;



// WEBPACK FOOTER //
// ./app/components/nn-translations/nn-translations-loader.factory.js